import { useState, useEffect } from 'react';
import { getJobById, IJob } from 'wisestep-api';

const useGetJob = (jobId: string) => {
  const [job, setJob] = useState<IJob>({} as IJob);

  useEffect(() => {
    (async () => {
      try {
        const res = await getJobById(jobId);
        setJob(res?.data);
      } catch (e) {
        console.error('Failed to load the Job Data', e);
      }
    })();
  }, [jobId]);

  return { job };
};

export default useGetJob;
